import { Adapter, SendToOptions } from './adapter';
import { getScript } from '../utils/http';
import { sleep } from '../utils/time';
import { isHeightVersionMSDK } from '../config';

// TODO: test
// TODO: need check
export default class AdapterImpl implements Adapter {
  public async init(): Promise<void> {
    if (typeof window.msdkShare !== 'function' || typeof window.msdkiOSHandler !== 'function') {
      await getScript('https://img.ssl.msdk.qq.com/wiki/msdkJsAdapter.js');
    }
  }
  public async sendTo(config: any, { channelID, ...shareConfig }: SendToOptions): Promise<void> {
    const { title, desc, url } = shareConfig;
    const imgUrl = shareConfig.imgUrl || config?.options?.msdkicon;
    let msdkShareData: any;
    switch (channelID) {
      case 'wxt': {
        msdkShareData = JSON.stringify(Object.assign(
          {
            MsdkMethod: 'WGSendToWeiXinWithUrl',
            scene: '1',
            mediaTagName: 'MSG_INVITE',
            messageExt: title,
            imgUrl,
          },
          shareConfig,
        ));
        break;
      }
      case 'wxf': {
        msdkShareData = JSON.stringify(Object.assign(
          {
            MsdkMethod: 'WGSendToWeiXinWithUrl',
            scene: '0',
            mediaTagName: 'MSG_INVITE',
            messageExt: title,
            imgUrl,
          },
          shareConfig,
        ));
        break;
      }
      case 'qqf': {
        msdkShareData = JSON.stringify({
          MsdkMethod: 'WGSendToQQ',
          scene: '2',
          title,
          desc,
          url,
          imgUrl,
        });
        break;
      }
      case 'qqz': {
        msdkShareData = JSON.stringify({
          MsdkMethod: 'WGSendToQQ',
          scene: '1',
          title,
          desc,
          url,
          imgUrl,
        });
        break;
      }
    }

    if (!isHeightVersionMSDK()) {
      (document.getElementsByClassName('msdkshare-layer')[0] as HTMLElement).style.display = 'block';
      await sleep(1000);
      try {
        window.msdkShare(msdkShareData);
      } catch (error) {
        console.error(error);
      }
      (document.getElementsByClassName('msdkshare-layer')[0] as HTMLElement).style.display = 'none';
    } else {
      // msdk组件分享方法
      window.msdkShare(msdkShareData);
    }
  }
};
